<template>
  <div class="donation-page">
    <header class="header">
      <h1>🎁 Doe Itens para Quem Precisa</h1>
      <p>🤝 Conectamos pessoas que querem doar itens com aquelas que precisam.</p>
    </header>
    
    <section class="how-it-works">
      <h2>📌 Como Funciona</h2>
      <div class="steps">
        <div class="step">
          <h3>1️⃣ Escolha o que doar</h3>
          <p>📦 Selecione itens em boas condições que você deseja doar.</p>
        </div>
        <div class="step">
          <h3>2️⃣ Cadastre a doação</h3>
          <p>📝 Registre sua doação para que interessados possam encontrá-la.</p>
        </div>
        <div class="step">
          <h3>3️⃣ Entregue o item</h3>
          <p>📍 Combine um local seguro para a entrega do item doado.</p>
        </div>
      </div>
    </section>
    
    <section class="donate-now">
      <h2>✨ Comece a Doar</h2>
      <p>✨ Faça a diferença na vida de alguém hoje.</p>
      
    </section>

    <section class="download-app">
      <h2>📲 Baixe o App</h2>
      <p>Disponível para Android 📱</p>
      <a href="#" class="google-play">
        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Baixar no Google Play">
      </a>
    </section>
  </div>
</template>

<script>
export default {
  name: 'DonationPage'
}
</script>

<style scoped>
.donation-page {
  text-align: center;
  padding: 20px;
  font-family: Arial, sans-serif;
}
.header {
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 10px;
}
.how-it-works {
  margin: 20px 0;
}
.steps {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.step {
  width: 30%;
  min-width: 250px;
  padding: 10px;
}
.donate-button {
  background-color: #28a745;
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 5px;
}
.donate-button:hover {
  background-color: #218838;
}
.download-app {
  margin-top: 20px;
}
.google-play img {
  width: 150px;
}
</style>